import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import ImageBox from "../assests/ImageBox";
import { formatDate } from "../configs/formatDate";
import StatusBadge from "../assests/StatusBadge";

function SettlementCard(props) {
  const { data } = props;
  const getDuestatus = (inputdate) => {
    const date = new Date(inputdate);
    const now = new Date();
    if (date < now) {
      return "OVER DUE AMOUNT";
    } else if (date > now) {
      return "REQUEST AMOUNT";
    }
  };
  return (
    <div className="card invoices-grid-card w-100">
      <Link to={`/manage-settlements/${data.id}`}>
        <div className="card-body">
          <div className="row align-items-center hospital-card">
            <div className="col">
              <ImageBox
                src={data?.hospital?.logo}
                alt={data?.hospital?.name || "Hospital Logo"}
                width="75px"
                height="75px"
              />
            </div>
            <div className="col-auto">
                <StatusBadge status={data.status}/>
            </div>
            <div className="row mt-3">
              <div className="col">
                <h5>{data?.hospital?.name}</h5>
              </div>
              {/* <div className="col-auto">
                <h5 className="text-primary">{data.status}</h5>
              </div> */}
            </div>

            <div className="row mt-2">
              <div className="col text-secondary align-middle">
                <p
                  className={`${
                    getDuestatus(data?.request_date) === "OVER DUE AMOUNT"
                      ? "custom-badge status-red"
                      : "custom-badge status-orange"
                  }`}
                >
                  {getDuestatus(data?.request_date)}
                </p>
              </div>
              <div className="col-auto">
                <h5 style={{fontSize:'1.3rem',fontWeight:'600'}}>₹ {data.amount}</h5>
              </div>
            </div>

            <div className="row">
              <p>Requested On {formatDate(data?.request_date)}</p>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}

SettlementCard.propTypes = {
  data: PropTypes.node,
};

export default SettlementCard;
